import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GalleryOptions } from '@twogate/ngx-photo-gallery/lib/interfaces/photoswipe';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-photo-gallery-dialog',
  templateUrl: './photo-gallery-dialog.component.html',
  styleUrls: ['./photo-gallery-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PhotoGalleryDialogComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];

  photoGalleryGroupOptions: GalleryOptions = {
    closeOnScroll: false,
    arrowEl: true,
    zoomEl: true,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PhotoGalleryDialogComponent>,
    public sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  close() {
    this.dialogRef.close();
  }

  extractVideoId(url: string): string | null {
    const regex =
      /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }
  getVideoURL() {
    let prefix = 'https://www.youtube.com/embed/';
    let videoId = this.extractVideoId(this.data.vesselVideo);
    let postfix =
      '?&loop=1&showinfo=0&playsinline=1&fs=1&showinfo=0&disablekb=1&autoplay=1&rel=0';
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      prefix + videoId + postfix,
    );
  }
}
